<template>
  <div>
    <b-jumbotron>
      <b-row align-h="between">
        <b-col cols="3">
          <div class="headerWrapper">
            <font-awesome-layers full-width class="fa-3x headerIcon">
              <font-awesome-icon icon="square" style="color: #4c7d7a" />
              <font-awesome-icon icon="heart" transform="shrink-7" style="color: white" />
            </font-awesome-layers>
            <div class="headline">
              <h5>Surgeon Preferences</h5>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-jumbotron>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>